import { render, staticRenderFns } from "./asistencias_list.vue?vue&type=template&id=cbade904&lang=pug&"
import script from "./asistencias_list.vue?vue&type=script&lang=js&"
export * from "./asistencias_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports